import { FeatureDefinition } from '@growthbook/growthbook-react';
import axios from 'axios';
import { decrypt } from 'src/workspace/queries';
import { getDecryptedEnvValue, isJsonString } from 'src/workspace/utils';
import { growthbook } from './index';

const FEATURES_ENDPOINT = `https://cdn.growthbook.io/api/features/${getDecryptedEnvValue(
  'GROWTHBOOK_KEY',
)}`;
const GROWTHBOOK_OVERRIDE_KEY = 'growthbook-overrides';
const EncryptKey = getDecryptedEnvValue('GROWTHBOOK_ENCRYPT_KEY');
export const initialiseFeatureFlagsFromGrowthBook = async (attributes) => {
  try {
    if (
      !['production', 'preProd'].includes(process.env.APP_ENV || '') &&
      localStorage.getItem(GROWTHBOOK_OVERRIDE_KEY)
    ) {
      const stringifiedValues =
        localStorage.getItem(GROWTHBOOK_OVERRIDE_KEY) ?? `{""}`;
      const evaluated = isJsonString(stringifiedValues)
        ? JSON.parse(stringifiedValues)
        : stringifiedValues;
      const features = Object.entries(evaluated).reduce((acc, [key, value]) => {
        acc[key] = { defaultValue: value };
        return acc;
      }, {} as Record<string, FeatureDefinition<any>>);
      growthbook.setFeatures(features);
    } else {
      const response = await axios({
        url: FEATURES_ENDPOINT,
        method: 'get',
        withCredentials: false,
      });

      if (response.status === 200) {
        const featuresStr = await decrypt(
          response.data.encryptedFeatures,
          String(EncryptKey),
        );
        const features = JSON.parse(featuresStr);
        if (attributes) {
          growthbook.setAttributes(attributes);
        }
        growthbook.setFeatures(features);
      } else {
        /* eslint-disable no-console */
        console.error('Failed to fetch feature definitions from GrowthBook');
      }
    }
  } catch (error) {
    /* eslint-disable no-console */
    console.error(error);
  }
};
